import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GtmService } from './services/gtm/gtm.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'client-payment-portal';

  constructor(private gtmService: GtmService, private router: Router) {}

  ngOnInit(): void {
    // Inicializar GTM cuando se carga la aplicación
    this.gtmService.initializeGTM();

    // Exponer el servicio GTM globalmente SOLO en desarrollo
    if (!environment.production) {
      (window as any).gtmService = this.gtmService;
    }

    // Detección de retorno desde Transbank con TBK_TOKEN en la URL principal (ej: http://localhost:4200?TBK_TOKEN=...)
    try {
      const url = new URL(window.location.href);
      const tbkToken = url.searchParams.get('TBK_TOKEN');
      if (tbkToken) {
        // Verificar si es un proceso de WebPay (cancelación o retorno)
        const processPayment = localStorage.getItem('process-payment');
        let isWebPay = false;
        if (processPayment) {
          try {
            const pp = JSON.parse(processPayment);
            if (pp.operatorCode === 0) {
              isWebPay = true;
            }
          } catch (e) {}
        }

        if (isWebPay) {
          console.log('🔍 TBK_TOKEN detectado pero es WebPay. Dejando que el flujo normal lo maneje.');
          return;
        }

        console.log('🔍 TBK_TOKEN detectado en URL:', tbkToken.substring(0, 10) + '...');

        // Guardar TBK_TOKEN en sessionStorage sin perder los datos locales existentes
        sessionStorage.setItem('TBK_TOKEN', tbkToken);
        // Limpiar el parámetro de la barra de direcciones para evitar recargas con token
        url.searchParams.delete('TBK_TOKEN');
        const cleanUrl = url.origin + url.pathname + (url.hash || '');
        window.history.replaceState({}, document.title, cleanUrl);

        // Redirigir a la vista de confirmación FE usando Angular Router
        const account = sessionStorage.getItem('oneclick-enroll-account') || localStorage.getItem('card-code') || '';
        console.log('📋 Account para confirmación:', account);

        if (account) {
          console.log('🚀 Iniciando navegación a /oneclick/confirm...');
          // Usar setTimeout para asegurar que Angular esté completamente inicializado
          setTimeout(() => {
            console.log('🔄 Ejecutando navegación...');
            this.router.navigate(['/oneclick/confirm']);
          }, 100);
        }
      }
    } catch (error) {
      console.error('❌ Error en detección TBK_TOKEN:', error);
    }
  }
}
